// extracted by mini-css-extract-plugin
module.exports = {"header":"provider_header_1kAKk","title":"provider_title_2BhiD","divider":"provider_divider_2ZqE6"};